<template>
  <div class="login">
    <div class="header">
      <img
        src="@/assets/images/LOGO.png"
        alt
        style="width:139px;height:22px;"
        @click="toPath()"
      />
    </div>
    <div class="main">
      <div class="loginlayer">
        <div class="left">
          <img
            src="@/assets/images/logobig.png"
            alt
            style="width:298px;height:47px;"
          />
          <div class="linear-gradient" style=" margin-top: 344px;">
            <canvas id="myCanvas" width="300" height="59"
              >您的浏览器不支持 HTML5 canvas 标签。</canvas
            >
          </div>
          <div class="linear-gradient">
            <canvas id="myCanvas2" width="300" height="59"
              >您的浏览器不支持 HTML5 canvas 标签。</canvas
            >
          </div>
        </div>
        <div class="right">
          <div style="font-size:30px;font-weight:bold;display:flex">
            <span style="color: #b3b3b3">用户</span>
            <span style="color: #2f2f2f">登录</span>
          </div>
          <div style="color: #999999;margin-top:17px;font-size: 12px;">
            Welcome Back,Please login to your account.
          </div>
          <el-form
            :model="loginForm"
            :rules="rules"
            ref="login_form"
            status-icon
            label-width="0px"
            class="login_form_bim"
          >
            <el-form-item prop="name" label="账号 Account">
              <el-input
                maxlength="50"
                size="small"
                placeholder="请输入账号"
                v-model="loginForm.name"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码 Password" class="mt-10">
              <el-input
                maxlength="20"
                size="small"
                placeholder="请输入密码"
                type="password"
                v-on:keyup.enter.native="submitClick()"
                v-model="loginForm.password"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-top:120px">
              <el-button @click="submitClick">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import aes from '@/uitls/aes'
import { setCookie, getUrlParams } from '@/uitls/index'

export default {
  name: 'login',
  data() {
    return {
      loginForm: {
        name: '',
        password: ''
      },
      rules: {
        name: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      name: '',
      password: ''
    }
  },
  mounted() {
    const c = document.getElementById('myCanvas')
    const ctx = c.getContext('2d')
    const mygradient = ctx.createLinearGradient(0, 0, 300, 0)
    mygradient.addColorStop(0.15, '#0088ff')
    mygradient.addColorStop(0.5, '#00bff9')
    mygradient.addColorStop(1, '#00f6f2')
    ctx.font = '16px Arial'
    ctx.fillStyle = mygradient
    ctx.fillText('打造专业模型数据服务', 0, 22)
    const c2 = document.getElementById('myCanvas2')
    const ctx2 = c2.getContext('2d')
    const mygradient2 = ctx2.createLinearGradient(0, 0, 300, 0)
    mygradient2.addColorStop(0.15, '#0088ff')
    mygradient2.addColorStop(0.5, '#00bff9')
    mygradient2.addColorStop(1, '#00f6f2')
    ctx2.font = '16px Arial'
    ctx2.fillStyle = mygradient2
    ctx2.fillText('用BIM给与您更准确数据支持', 0, 22)
  },
  components: {},
  methods: {
    toPath() {
      window.location.href = process.env.BP_TARGET
    },
    submitClick() {
      this.$refs.login_form.validate(valid => {
        if (valid) {
          this.$http
            .post('/user-server/user/pc_login.do', {
              userAccount: this.loginForm.name,
              loginType: 1,
              password: aes.Encrypt(this.loginForm.password)
            })
            .then(res => {
              if (res.data.code == 200) {
                // 登录成功将token缓存在cookie
                setCookie('accesstoken', res.data.value, 1)
                this.$message.success(res.data.message)

                window.location.href = process.env.BP_TARGET
              } else if (res.data.code == 10011) {
                // TODO: unify login logic
                setCookie('accesstoken', res.data.value, 1)
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      })
    }
  }
}
</script>
<style lang="scss" scope>
.login {
  font-family: Microsoft YaHei, Arial, Helvetica Neue, Helvetica, PingFang SC,
    Hiragino Sans GB, sans-serif;
  .el-input--medium .el-input__inner {
    border-radius: 1px;
  }
}
.login_form_bim {
  margin-top: 50px;
  .el-form-item__label {
    float: none;
    color: rgb(176, 186, 196);
  }
  .el-form-item__content {
    // line-height: normal;
  }
  label::before {
    content: '' !important;
  }
  button {
    width: 100%;
    height: 40px;
    font-size: 14px;
    border-radius: 1px;
    background-image: linear-gradient(90deg, #23c5ff, #2275fe);
    color: #fff;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
      color: #fff;
    }
    &:active {
      background: #3a8ee6;
      border-color: #3a8ee6;
      color: #fff;
    }
  }
}
</style>

<style scoped>
.login {
  width: 100%;
  height: 100%;
  position: relative;
}
.header {
  width: 100%;
  height: 60px;
  padding-left: 55px;
  padding-top: 16px;
  background: #181a1d;
}
.main {
  width: 100%;
  height: calc(100% - 60px);
  background: url('./../../assets/images/logobg.png') no-repeat 0px 0px;
  background-size: 100% 100%;
}
.loginlayer {
  height: 582px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -496px;
  margin-top: -290px;
  display: flex;
}
.left {
  width: 506px;
  height: 100%;
  background: url('./../../assets/images/denglubg.png') no-repeat 0px 0px;
  background-size: 100% 100%;
  padding: 60px 0px 0px 54px;
}
.right {
  width: 486px;
  height: 100%;
  padding: 60px 68px 0px 60px;
  background: white;
}
.linear-gradient {
  width: 100%;
  height: 24px;
}
.loginbottom {
  width: 100%;
  height: 40px;
  font-size: 14px;
  border-radius: 1px;
  background-image: linear-gradient(90deg, #23c5ff 0%, #2275fe 100%);
}
</style>



// WEBPACK FOOTER //
// src/views/bimplus/index.vue